export const getItalyData = () => ({
  name: "Italie",
  description: "L'Italie est l'un des plus grands producteurs de vin au monde, avec une tradition viticole millénaire et une diversité de cépages et de styles uniques.",
  type: "country",
  regions: [
    { name: "Toscane", area: "63,000 ha", percentage: "9.0%", description: "Chianti, Brunello, Super Tuscans" },
    { name: "Piémont", area: "46,000 ha", percentage: "6.6%", description: "Barolo, Barbaresco, Asti" },
    { name: "Vénétie", area: "84,000 ha", percentage: "12.0%", description: "Prosecco, Valpolicella, Soave" },
    { name: "Sicile", area: "98,000 ha", percentage: "14.0%", description: "Nero d'Avola, Etna, Marsala" },
    { name: "Pouilles", area: "106,000 ha", percentage: "15.1%", description: "Primitivo, Negroamaro" },
    { name: "Émilie-Romagne", area: "58,000 ha", percentage: "8.3%", description: "Lambrusco, Sangiovese" },
    { name: "Lombardie", area: "23,000 ha", percentage: "3.3%", description: "Franciacorta, Valtellina" },
    { name: "Trentin-Haut-Adige", area: "13,000 ha", percentage: "1.9%", description: "Pinot Grigio, Gewürztraminer" },
    { name: "Frioul-Vénétie Julienne", area: "18,000 ha", percentage: "2.6%", description: "Pinot Grigio, Sauvignon" },
    { name: "Abruzzes", area: "32,000 ha", percentage: "4.6%", description: "Montepulciano d'Abruzzo" },
    { name: "Marches", area: "25,000 ha", percentage: "3.6%", description: "Verdicchio, Rosso Conero" },
    { name: "Campanie", area: "41,000 ha", percentage: "5.8%", description: "Taurasi, Fiano, Greco" },
    { name: "Autres", area: "95,000 ha", percentage: "13.5%", description: "Dispersées dans le pays" }
  ],
  mapAreas: [
    { region: "Toscane", x: 11.0, y: 43.5, color: "#4B164C", size: 6 },
    { region: "Piémont", x: 7.5, y: 44.5, color: "#6d2c7a", size: 5 },
    { region: "Vénétie", x: 12.0, y: 45.5, color: "#8a4a8a", size: 6 },
    { region: "Sicile", x: 14.0, y: 37.5, color: "#a768a6", size: 7 },
    { region: "Pouilles", x: 16.5, y: 41.0, color: "#c486c2", size: 6 },
    { region: "Émilie-Romagne", x: 11.5, y: 44.5, color: "#d4a4d0", size: 5 },
    { region: "Lombardie", x: 9.5, y: 45.5, color: "#e4c2de", size: 4 },
    { region: "Trentin-Haut-Adige", x: 11.0, y: 46.5, color: "#f4e0ec", size: 3 },
    { region: "Frioul-Vénétie Julienne", x: 13.5, y: 46.0, color: "#f0e6f0", size: 3 },
    { region: "Abruzzes", x: 13.5, y: 42.5, color: "#e8e0e8", size: 4 },
    { region: "Marches", x: 13.0, y: 43.5, color: "#e0dae0", size: 3 },
    { region: "Campanie", x: 14.5, y: 40.5, color: "#d8d4d8", size: 4 }
  ],
  statistics: {
    totalArea: "702,000 ha",
    production: "48,000,000 hl",
    wineries: "310,000+ domaines",
    regions: "20 régions viticoles",
    exportPercentage: "65%"
  },
  characteristics: {
    climate: "Climat méditerranéen varié, des Alpes au sud",
    soil: "Sols très diversifiés : calcaires, volcaniques, argileux",
    viticulture: "Tradition millénaire, cépages autochtones, DOC/DOCG"
  },
  wineStyles: {
    red: "Rouges puissants (Barolo, Brunello), légers (Chianti), fruités (Valpolicella)",
    white: "Blancs secs (Pinot Grigio), aromatiques (Gewürztraminer), effervescents (Prosecco)",
    sparkling: "Prosecco, Franciacorta, Asti Spumante",
    dessert: "Vin Santo, Recioto, Passito"
  },
  history: "L'Italie produit du vin depuis l'Antiquité romaine. Chaque région a développé ses propres traditions et cépages autochtones.",
  foodPairing: "Cuisine italienne traditionnelle, fromages affinés, charcuteries, pâtes et pizzas"
}); 